import { rootApi } from "../../api/rootApi";

export const whatsappLoggingApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getWhatsappLogging: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/whatsappLogging`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body
        };
      },
    }),
    getWhatsappLoggingTotalCount: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/whatsappLogging/count`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body
        };
      },
    }),

  }),
});
export const { useGetWhatsappLoggingMutation,useGetWhatsappLoggingTotalCountMutation } = whatsappLoggingApi;
